<template>
  <el-input
    v-model="vesselAndVoyage"
    :disabled="disabled"
    @change="onVesselAndVoyageChange"
  />
</template>

<script>
export default {
  name: 'SeVesselAndVoyage',
  props: {
    job: { type: Object, default: () => { return {} } },
    showJudgmentOfVoyageNo: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      vesselAndVoyage: (this.job.vessel || '') + ' ' + (this.job.voyageFlight || '')
    }
  },
  methods: {
    onVesselAndVoyageChange(value) {
      if (!value) {
        this.job.voyageFlight = ''
        this.job.vessel = ''
      }
      if (value && value.trim().length > 0) {
        const parts = value.trim().split(/[\s\/]+/)
        if (parts.length > 1) {
          // 如果有多个部分，最后一个作为航次，其余作为船名
          let voyageFlight = parts.pop() // 获取最后一个单词作为航次
          const vessel = parts.join(' ') // 其他部分作为船名
          if (this.showJudgmentOfVoyageNo && !voyageFlight.toUpperCase().includes('V.')) {
            voyageFlight = 'V.' + voyageFlight
          }
          this.job.voyageFlight = voyageFlight
          this.job.vessel = vessel
        } else {
          // 如果只有一个部分，默认全部为船名
          this.job.vessel = value.trim() // 全部内容作为船名
        }
      }
      this.$emit('childrenChange', [{ key: 'vessel', value: this.job.vessel }, { key: 'voyageFlight', value: this.job.voyageFlight }])
    }
  }
}
</script>
